angular.module('angus.controllers').controller('adeptPerformanceAnalysisSettingsCtrl', [
    '$scope', '$q', 'adeptPerformanceAnalysisService', 'adeptService', 'containerService', 'deliveryTypeService', 'productsService', 'promiseMonitor',
    function ($scope, $q, adeptPerformanceAnalysisService, adeptService, containerService, deliveryTypeService,  productsService, promiseMonitor) {

        $scope.subscriberId;

        $scope.timePeriods = adeptPerformanceAnalysisService.getTimePeriods();

        $scope.useAdeptGroupChanged = useAdeptGroupChanged;

        $scope.adeptGroupChanged = () => loadContainerTypes();
        $scope.productCategoriesChanged = () => loadContainerTypes();
        $scope.deliveryTypesChanged = () => loadContainerTypes();
        $scope.containerTypeChanged = () => $scope.persistedSettings.containerTypeId = $scope.settings.containerTypeId.value;

        $scope.persistedSettings = {
            adeptGroupIds: [],
            productCategoryIds: [],
            deliveryTypeIds: [],
            containerTypeId: $scope.settings.containerTypeId.value
        }

        function useAdeptGroupChanged() {
            if ($scope.settings.useAdeptGroup.value) {
                /*Store the values of the disabled controls in case they toggle the Use ADEPT Group option again before leaving the screen. */
                $scope.persistedSettings.productCategoryIds = $scope.settings.productCategoryIds.value;
                $scope.persistedSettings.deliveryTypeIds = $scope.settings.deliveryTypeIds.value;
                
                /* Clear out values for Disabled controls. */
                $scope.settings.productCategoryIds.value = [];
                $scope.settings.deliveryTypeIds.value = [];

                /* If we had a Persisted ADEPT Group then use it. */
                $scope.settings.adeptGroupIds.value = $scope.persistedSettings.adeptGroupIds;
            }
            else {
                /* Clear out values for Disabled controls. Store the values in case they toggle the Use ADEPT Group option again before leaving the screen. */
                $scope.persistedSettings.adeptGroupIds = $scope.settings.adeptGroupIds.value;
                $scope.settings.adeptGroupIds.value = [];

                /* If we had a Persisted settings then use them. */
                $scope.settings.productCategoryIds.value = $scope.persistedSettings.productCategoryIds;
                $scope.settings.deliveryTypeIds.value = $scope.persistedSettings.deliveryTypeIds;
            }

            loadContainerTypes();

        }

        function loadContainerTypes() {
            $scope.containerTypes = [];
            $scope.settings.containerTypeId.value = null;
            
            const useAdeptGroup = $scope.settings.useAdeptGroup.value;

            const subscriberId = $scope.subscriberId;

            let promise;
            if(useAdeptGroup)
            {
                const adeptGroupIds = $scope.settings.adeptGroupIds.value;

                promise = containerService.getContainerTypes(subscriberId, undefined, undefined, undefined, undefined, adeptGroupIds);
            }
            else {
                const productCategoryIds = $scope.settings.productCategoryIds.value;
                const deliveryTypeIds = $scope.settings.deliveryTypeIds.value;

                promise = containerService.getContainerTypes(subscriberId, undefined, productCategoryIds, undefined, deliveryTypeIds, undefined);
            }

            $scope.areContainerTypesLoading = true;
            
            return promise.then(function(containerTypes){
                $scope.containerTypes = containerTypes;

                const persistedContainerTypeId = $scope.persistedSettings.containerTypeId;

                if (persistedContainerTypeId)
                {
                    const containerTypeMatch = containerTypes.find(containerType => containerType.id == persistedContainerTypeId);

                    if (containerTypeMatch) {
                        $scope.settings.containerTypeId.value = containerTypeMatch.id.toString(); /* Not entirely sure why this needs to be a String. Angular?? */
                    }
                }

                $scope.areContainerTypesLoading = false;
            });
        }

        $scope.promiseMonitor = new promiseMonitor();

        const promise = $q.all([
            adeptService.getAdeptGroupsLegacy($scope.subscriberId)
                .then(function(adeptGroups) {
                    $scope.adeptGroups = adeptGroups;
                }),
            deliveryTypeService.getDeliveryTypes($scope.subscriberId)
                .then(function(deliveryTypes) {
                    $scope.deliveryTypes = deliveryTypes;
                }),
            productsService.getProducts($scope.subscriberId)
                .then(function(productCategories) {
                    $scope.productCategories = productCategories;
                }),
            loadContainerTypes()
        ]);

        $scope.promiseMonitor.monitor(promise);

    }
]);